import api from "../../index.js";

export const GetWithdrawApi = () => api.get(`WalletMaster/Get-Withdraw-Type`);
export const GetWithdrawnewApi = (params) => api.get(`Withdraw/GetWithdraw-RequestByUserId?${params}`);
export const GetWalletApi = (userId, params) => api.get(`WalletMaster/Get-WalletDetailsByRule/${userId}?${params}`);
export const AddWithdrawRequestApi = (data) => api.post('Withdraw/Create-Withdraw-Request', data);
export const GetCredentialsApi = (params) => api.get(`UserMaster/credentials?${params}`);